import * as React from "react";
import {ShoppingBasket} from "../../models/ShoppingBasket";
import {ShoppingBasketLineItem } from "../../models/ShoppingBasketLineItem";
import {Customer} from "../../models/Customer";
import {MoneyDisplay} from "../common/MoneyDisplay";
import {TextBox} from "../common/TextBox";

export class CartViewerTotalsProps
{
	shoppingBasket: ShoppingBasket;
	showShipping: boolean;
}

export class CartViewerTotals extends React.Component<CartViewerTotalsProps, any>
{
	render()
	{
		return <table className="shoppingbasket-totals table">
			       <tbody>
			       {this.renderSubtotal() }
			       {this.renderProductDiscount() }
			       {this.renderMemberDiscount() }
			       {this.renderPromoDiscount() }
			       {this.renderShipping() }
			       {this.renderServiceCharge() }
			       {this.renderTax() }
			       {this.renderGrandTotal() }
			       </tbody>
		       </table>;
	}

	private renderSubtotal()
	{
		const shoppingBasket = this.props.shoppingBasket;
		return <tr>
			       <td>
				       <h4>{shoppingBasket.lineItemTotalQuantity} Item{shoppingBasket.lineItemTotalQuantity > 1 ? "s" : ""}: </h4>
			       </td>
			       <td>
				       <h4>
					       <MoneyDisplay amount={shoppingBasket.lineTotal}/>
				       </h4>
			       </td>
		       </tr>;
	}

	private renderProductDiscount()
	{
		const shoppingBasket = this.props.shoppingBasket;
		if (shoppingBasket.productDiscount !== 0)
		{
			return <tr>
				       <td>Product Discount: </td>
				       <td>
					       <MoneyDisplay amount={shoppingBasket.productDiscount}/>
				       </td>
			       </tr>;
		}
		return null;
	}

	private renderMemberDiscount()
	{
		const shoppingBasket = this.props.shoppingBasket;
		if (shoppingBasket.memberDiscount !== 0)
		{
			return <tr>
				       <td>Member Discount: </td>
				       <td>
					       <MoneyDisplay amount={shoppingBasket.memberDiscount}/>
				       </td>
			       </tr>;
		}
		return null;
	}

	private renderPromoDiscount()
	{
		const shoppingBasket = this.props.shoppingBasket;
		if (shoppingBasket.promoDiscount !== 0)
		{
			return <tr>
				       <td>Promo Discount: </td>
				       <td>
					       <MoneyDisplay amount={shoppingBasket.promoDiscount}/>
				       </td>
			       </tr>;
		}
		return null;
	}

	private renderShipping()
	{
		const shoppingBasket = this.props.shoppingBasket;

		if (this.props.showShipping === false)
		{
			return null;
		}

		return <tr>
			       <td>Shipping & Handling: </td>
			       <td>
				       {shoppingBasket.isShippingTBD ? "TBD" : <MoneyDisplay amount={shoppingBasket.shippingHandling}/>}
			       </td>
		       </tr>;
	}

	private renderServiceCharge()
	{
		const shoppingBasket = this.props.shoppingBasket;
		if (shoppingBasket.serviceCharge !== 0)
		{
			return <tr>
				       <td>Service Charge: </td>
				       <td>
					       <MoneyDisplay amount={shoppingBasket.serviceCharge}/>
				       </td>
			       </tr>;
		}
		return null;
	}

	private renderTax()
	{
		const shoppingBasket = this.props.shoppingBasket;
		return <tr>
			       <td>Estimated Tax: </td>
			       <td>
				       {shoppingBasket.isTaxTBD ? "TBD" : <MoneyDisplay amount={shoppingBasket.estimatedTax}/>}
			       </td>
		       </tr>;
	}

	private renderGrandTotal()
	{
		const shoppingBasket = this.props.shoppingBasket;
		return <tr>
			       <td>
				       <h3>Grand Total</h3>
			       </td>
			       <td>
				       <h3>
					       <MoneyDisplay amount={shoppingBasket.grandTotal}/>
				       </h3>
			       </td>
		       </tr>;
	}
}


// WEBPACK FOOTER //
// ./src/components/shoppingbasket/CartViewerTotals.tsx